/**
 * SEV Onboarding Routes
 *
 * Route definitions for the SEV onboarding module.
 */

import { lazy } from 'react';

const SEVOnboardingManagement = lazy(() => import('@/pages/sev-onboarding/SEVOnboardingManagement'));
const SEVStatementDetailView = lazy(() => import('@/pages/sev-onboarding/SEVStatementDetailView'));
const OwnerSevStatementPayoutRedirect = lazy(() => import('@/pages/sev-onboarding/OwnerSevStatementPayoutRedirect'));

export const sevOnboardingRoutes = [
    {
        path: 'sev-onboarding',
        element: <SEVOnboardingManagement />,
    },
    /** Deep-link helper: Cockpit used numeric `investorYearlyPayoutId` in the URL; RAM uses `/owners/:id/sev-statements/:year`. */
    {
        path: 'investor-yearly-payout/:payoutId',
        element: <OwnerSevStatementPayoutRedirect />,
    },
    {
        path: 'owners/:id/sev-statements/:year',
        element: <SEVStatementDetailView />,
    },
];
